import * as React from "react";
import Button from "@mui/material/Button";

export default function CustomButton({ varient, isDisabled, lable, onClick }) {
  return (
    <Button
      sx={{ fontSize: 10, margin: 1, height: 40 }}
      onClick={onClick}
      variant={varient}
      disabled={isDisabled}
      style={{ backgroundColor: isDisabled ? "grey" : "blue" }}
    >
      {lable}
    </Button>
  );
}
